module.exports = __webpack_public_path__ + "static/media/micro-set.b107aee9.png";